import Isotope from 'isotope-layout';


document.addEventListener( 'DOMContentLoaded' , function() {

  const isoExists = document.querySelector('.isotope');
  isoExists.classList.add('is-loading');

  if (isoExists) {
    
    const iso_events = new Isotope( '.isotope--work', {
      itemSelector: '.isotope__card',
      layoutMode: 'masonry',
      getSortData: {
        date: '[data-date]',
      },
      sortBy: ['date'],
      sortAscending: false,
      masonry: {
        gutter: 12,
      }
    });
    
    window.addEventListener( 'load' , function() {
      isoExists.classList.add('is-loaded');
      isoExists.classList.remove('is-loading');

      // redo layout on load to fix irregular whitespace issue
      iso_events.arrange( { filter: '.header' });
      iso_events.layout();
      window.scrollTo({ top: 0, behavior: 'instant' });
    });

    /*
    window.onload = function() {
      
      isoExists.classList.add('is-loaded');
      isoExists.classList.remove('is-loading');

      // redo layout on load to fix irregular whitespace issue
      iso_events.arrange( { filter: '.header' });
      iso_events.layout();
  
    };
    */
  
  
    // bind sort button click
    const sortByGroup = document.querySelector('.isotope__sort-by-button-group') ?? false;
    
    if ( sortByGroup ) {
    
      sortByGroup.addEventListener( 'click', function( event ) {
      
        var sortValue = event.target.getAttribute('data-sort-value');
        iso_events.arrange({ sortBy: sortValue });
      
      });
  
    }

    // bind filter button click
    const filtersElem = document.querySelectorAll('.isotope__filter-button-group') ?? false;
    
    if ( filtersElem ) {
      
      for ( var i=0; i < filtersElem.length; i++ ) {
        
        filtersElem[i].addEventListener( 'click', function( event ) {
      
          var filterValue = event.target.getAttribute('data-filter');
          iso_events.arrange({ filter: filterValue });
      
        });
  
      };
  
    }

    // combine filters
    var filters = {};
  
    const isoFilters = document.querySelector('.isotope-filters') ?? false;
  
    if ( isoFilters ) {
  
      isoFilters.addEventListener( 'click', function(event) {
      
        if ( event.target.matches(".isotope__button") ) {
  
          var targetedButton = event.target;
          // get group key
          var targetedButtonGroup = targetedButton.parentElement;
          var filterGroup = targetedButtonGroup.getAttribute('data-filter-group');
          // set filter for group
          filters[ filterGroup ] = targetedButton.getAttribute('data-filter');
          // combine filters
          var filterValue = concatValues( filters );
          // filter isotope
          iso_events.arrange({ filter: filterValue} );
        }
  
      });

    }


    function concatValues( obj ) {
  
      var value = '';
      for ( var prop in obj ) {
        value += obj[ prop ];
      }
      return value;
  
    }
  
  
    // toggle is-checked on iso buttons
    var buttonGroups = document.querySelectorAll('.isotope__button-group');
  
    for ( var i=0, len = buttonGroups.length; i < len; i++ ) {
  
      var buttonGroup = buttonGroups[i];
      radioButtonGroup( buttonGroup );
  
    }
    

    function radioButtonGroup( buttonGroup ) {
      buttonGroup.addEventListener( 'click', function( event ) {
  
        // only work with buttons
        if ( ! event.target.matches( 'button' ) ) {
          return;
        }
        buttonGroup.querySelector('.is-checked').classList.remove('is-checked');
        event.target.classList.add('is-checked');
        
      });
  
    }
  
    
    // dropdown open / close
    const dropdownButton = document.querySelector('.isotope__dropdown-button');
    if ( dropdownButton ) {

      dropdownButton.addEventListener( 'click', function() {
  
        this.parentElement.classList.toggle('is-open');
  
      });

    }
   
  }

});